<app-header></app-header>
<ion-content fullscreen scrollY="false" class="padding content" layout="row">
  <app-rows></app-rows>
</ion-content>
<ion-footer></ion-footer>
